import React from 'react';
import PropTypes from 'prop-types';

const CancelCircle = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="cancel--circle" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,10.8791766 L16.1470465,6.73213012 C16.4565533,6.42262329 16.958363,6.42262329 17.2678699,6.73213012 C17.5773767,7.04163695 17.5773767,7.54344667 17.2678699,7.8529535 L13.1208234,12 L17.2678699,16.1470465 C17.5773767,16.4565533 17.5773767,16.958363 17.2678699,17.2678699 C16.958363,17.5773767 16.4565533,17.5773767 16.1470465,17.2678699 L12,13.1208234 L7.8529535,17.2678699 C7.54344667,17.5773767 7.04163695,17.5773767 6.73213012,17.2678699 C6.42262329,16.958363 6.42262329,16.4565533 6.73213012,16.1470465 L10.8791766,12 L6.73213012,7.8529535 C6.42262329,7.54344667 6.42262329,7.04163695 6.73213012,6.73213012 C7.04163695,6.42262329 7.54344667,6.42262329 7.8529535,6.73213012 L12,10.8791766 Z" id="Combined-Shape" fill={color}></path>
      </g>
    </svg>
  );
}

CancelCircle.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

CancelCircle.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default CancelCircle;



// WEBPACK FOOTER //
// ./src/components/Icons/CancelCircle.jsx